import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

import { ServicoMsg } from '../../servicos/srv.msg';
import { ServicoRede } from '../../servicos/srv.rede';

@Component({
  selector: 'tsv2-rde-visualizar',
  templateUrl: './visualizar.component.html',
  providers: [ ServicoMsg, ServicoRede ]
})
export class RedeVisualizarComponent implements OnInit {
  exibirBarra: boolean = true;

  p: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private servicoMsg: ServicoMsg,
    private servicoRede: ServicoRede
  ) { }

  ngOnInit() {
    // this.spinner.show();
    const id = this.route.snapshot.params['id'];
    this.servicoRede.consultarRede(id).subscribe(res => {
      this.p = res.lista[0];
      // this.spinner.hide();
    }, (err) => {
      // this.spinner.hide();
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

  removerRede(id){
    let titulo = 'Remover a rede?';
    let url = '/rede/pesquisar/';
    let texto = 'Rede removida com sucesso!';
    this.servicoMsg.exibeAlerta(titulo, id, this.servicoRede, texto).then(r1 => {
      if (r1.success){
        this.router.navigate([url]);
      }
    }, (err: any) => {
      // this.spinner.hide();
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

}
